import { render, staticRenderFns } from "./PermissionsDepartmentById.vue?vue&type=template&id=024e7ecb&scoped=true&"
import script from "./PermissionsDepartmentById.vue?vue&type=script&lang=js&"
export * from "./PermissionsDepartmentById.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsDepartmentById.vue?vue&type=style&index=0&id=024e7ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e7ecb",
  null
  
)

export default component.exports